var exports = {
  "Xh": "x61f99309--5ea3d0--username",
  "hD": "x61f99309--5ea3d0--quote",
  "Zp": "x61f99309--5ea3d0--layout",
  "Qs": "x61f99309--5ea3d0--content",
  "mI": "x61f99309--5ea3d0--meta",
};

module.exports = exports;
